module.exports = __webpack_public_path__ + "img/time.fd179e74.png";